import type {ExtraInfo} from './types';

const DATA: ExtraInfo = {
  surveyUrl: 'https://forms.gle/QuCJMGJkBFVX4arS8',
  checkInCode: '0845',
  details: [
    {
      type: 'description',
      heading: 'Event Overview',
      paragraphs: [
        {
          content:
            'Curious about what it’s like to intern at a startup in Japan? Wondering how to find the right opportunity, what to expect, or how others have made the most of their internship experience?',
        },
        {
          content:
            'Join us for an evening of shared stories and meaningful conversations with students, from Japan and overseas,  currently interning at Tech startups in Japan. Through panel discussions and casual networking, you’ll hear firsthand stories from interns —what they worked on, changes  they faced, and how the experience has shaped their future plans.',
        },
        {
          content:
            'This event offers a unique opportunity to connect not only with peers who share your interests but also with startup founders and teams who are open to hosting interns, whether paid or unpaid. You’ll get a better sense of how internships at startups differ from those at larger companies, offering more hands-on experience, greater flexibility, and closer exposure to real-world business decisions.',
        },
        {
          content:
            "Whether you're already interning or just beginning to explore the possibilities, this event will help you understand what makes startup internships both exciting and valuable—and how to make the most of yours.",
        },
        {
          content:
            'We look forward to welcoming you into this growing community of students and professionals shaping the future of work in Japan’s startup scene.',
        },
      ],
    },
    {type: 'registration-form'},
    {
      type: 'list',
      heading: 'Who is this for',
      items: [
        'Students currently interning at a startup in Japan',
        'Students interested in interning at startups',
        'Students exploring career paths in tech startups',
        'Startup founders or teams interested in hosting interns',
        'University faculty looking to develop internship programs with startups',
      ],
    },
    {
      type: 'description',
      heading: 'Intern Spotlight (Coming Soon)',
      paragraphs: [
        {
          content:
            'We’re excited to introduce the students joining this summer’s internship program in Tokyo! ',
        },
        {
          content:
            'Starting July 15, we’ll be sharing short profiles highlighting their backgrounds, host companies, internship experiences, and key accomplishments.',
        },
      ],
    },
    {
      type: 'schedule',
      heading: 'Timetable',
      items: [
        {
          timeUTC: 1754386200,
          description: 'Doors Open',
        },
        {
          timeUTC: 1754388000,
          description: 'Welcome & Introductions',
        },
        {
          timeUTC: 1754388900,
          description: 'Intern Highlights ',
        },
        {
          timeUTC: 1754389800,
          description: 'Panel Discussion — Navigating Internships at Startups',
        },
        {
          timeUTC: 1754392500,
          description: 'Group Photo & Networking',
        },
        {
          timeUTC: 1754396100,
          description: 'Closing',
        },
        {
          timeUTC: 1754397000,
          description: 'Doors Close',
        },
      ],
    },
    {
      type: 'description',
      heading: 'Important Information',
      paragraphs: [
        {
          content:
            'Application: Please register by Friday, August 1st, 2025, to secure your spot. Participation is subject to approval. A short survey will follow your registration, and confirmed attendees will receive a calendar invite.',
        },
        {
          content:
            'Language: The event will primarily be conducted in English. During networking time, conversations in both English and Japanese are welcome.',
        },
        {
          content:
            'Refreshments: Light refreshments will be provided; please manage any allergies accordingly. You are welcome to bring your own snacks and soft drinks.',
        },
        {
          content:
            'Photography: Photos and videos may be taken during the event and could be used for promotional purposes on alliz’s website and social media. By signing up for this event, you permit us to use these photos and videos. If you do not want to be photographed but still wish to attend, please contact alliz.',
        },
        {
          content:
            'Schedule: The event schedule is subject to change on the day.',
        },
        {
          content:
            'Contact: For any event-related inquiries, please contact alliz via email at event@alliz.jp.',
        },
      ],
    },
    {
      type: 'description',
      heading: 'Hosts & Sponsors',
      paragraphs: [
        {
          heading: 'Host: alliz',
          content:
            'alliz is a member-led career mentorship community dedicated to helping students and early-career professionals with career design and development in Japan. Through events, mentorship, and shared learning, we foster connections that inspire personal growth, skill development, and long-term success in the tech industry.',
        },
        {
          heading:
            'Food & Drinks Sponsor: Council on International Educational Exchange',
          content:
            'Council on International Educational Exchange (CIEE), a non-profit founded in 1947, promotes global education through exchange programs. Since 1998, our Tokyo Center at Sophia University has hosted American students. Around 800 U.S. students join CIEE programs in Japan annually. Our Internship Program provides hands-on business experience while offering companies fresh global insights. We support students and hosts, fostering cross-cultural understanding and aiding companies in sustainable international growth.',
        },
        {
          heading: 'Event Space Sponsor: Google for Startups',
          content: '',
        },
        {
          heading: 'Photography Sponsor: E’s Eye - Estelle Etourneau',
          content:
            'Estelle Etourneau is originally from Bordeaux, France, and has been living in Japan for over 12 years. While drawing required a kind of discipline that didn’t resonate with her, photography offered a more immediate and intuitive way to create. What began as a way to preserve cherished moments with family and friends has grown into an important form of expression.',
        },
        {
          content:
            'Today, through the lens, E’s Eye, the creative lens of Estelle, captures the world as she sees it. Though not a professional photographer, E’s Eye is honored to be part of Alliz’s journey and grateful for the trust she placed in immortalizing these events.',
        },
      ],
    },
  ],
  tags: [],
  thumbnailURL: '/static/images/kMASOkQt47/bYdbffEBVPVb3hdtaknKbTSZuwFSdXp6.png',
};

export default DATA;
